// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"ForSorting_checkbox__OE1x3","checkedCheckbox":"ForSorting_checkedCheckbox__3wu9C","sortingBox":"ForSorting_sortingBox__1TIsw"};